import { render, staticRenderFns } from "./LoadingDialogCompo.vue?vue&type=template&id=cb5f51c4&scoped=true&"
import script from "./LoadingDialogCompo.vue?vue&type=script&lang=js&"
export * from "./LoadingDialogCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f51c4",
  null
  
)

export default component.exports